import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BatchReportsGridEvent } from '../../batch-reports-grid/batch-reports-grid-types';
import { DataGridCreatedEvent } from '../crm-report-datagrid/crm-report-datagrid-defns';

@Component({
  selector: 'app-crm-batch-reports',
  templateUrl: './crm-batch-reports.component.html',
  styleUrls: ['./crm-batch-reports.component.scss']
})
export class CrmBatchReportsComponent implements OnInit {

  showTabPanel = false;

  jobID1: string = '';
  title1: string = '';
  reportType1: string = '';
  
  jobID2: string = '';
  title2: string = '';
  reportType2: string = '';

  reportList: string[] = [];
  prevReportRefID: string = '';

  constructor(private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  onBatchGridEvent($event: BatchReportsGridEvent){
    
    console.log($event);
    
    /* if($event.subject == 'job'){
      if($event.eventType == 'view_report'){
        
        this.showTabPanel = false;
        this.updateTabProperties($event);
        this.rerender();               
      }
    } */
  }

  updateTabProperties($event: BatchReportsGridEvent){
    
    this.title1 = $event.data.reportSubType;
    this.jobID1 = $event.data.jobID;   
    this.reportType1 = this.getReportTypeForGrid($event.data.reportSubType);
  }

  getReportTypeForGrid(reportSubType: string){

    if(reportSubType == 'Suspects from D&B, all Segments'){
      return "CRM_Suspects";
    }else{
      return "CRM_Prospects";
    }
  }
  rerender() {    
    this.showTabPanel = false;    
    this.changeDetectorRef.detectChanges();
    this.showTabPanel = true;
  }

  onDataGridCreated(event: DataGridCreatedEvent){       
    
  }

}
